import script from "./CustomConfirmDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomConfirmDialog.vue?vue&type=script&setup=true&lang=js"

import "./CustomConfirmDialog.vue?vue&type=style&index=0&id=35f15e65&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35f15e65"]])

export default __exports__